import { ExpenseReport } from "app/finance/expense/expense-report";
import { PurchaseRequisition } from "../../procurement/purchase-requisition/purchase-req";
import {JobRequisition} from "@app/hcm/recruit-to-hire/job-req/job-req";


export class Template {
  id: number;

  expenseReportId: number;
  description: string;

  purchaseReqId: number;
  templateDescrip: string;

  salesOrderId: number;
  userId: number;

  jobRequisitionId: number;
}

export class TemplateRequest {
  request: string;    // load or save
  template: Template;
}
